export * from './TableHeader.styled';
